export default __webpack_public_path__ + "static/grinders-34b313ffa289d3ebf707f4531fcea053.png";